var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('nood-ken-a'),_c('nood-ken-b'),_c('nood-ken-c'),_c('nood-ken-d'),_c('nood-ken-e'),_c('nood-ken-f')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }